import { createStyles } from '@mantine/core'
type StylesParams = {
  bgColor: string
  noPadding?: boolean
  hasColor: boolean
}

export default createStyles(
  (theme, { hasColor, bgColor, noPadding }: StylesParams) => {
    return {
      root: {
        backgroundColor: bgColor,
        ...(!noPadding && {
          paddingTop: hasColor ? 80 : 40,
          paddingBottom: hasColor ? 80 : 40,
          [theme.fn.smallerThan('sm')]: {
            paddingTop: 32,
            paddingBottom: 32,
          },
        }),
      },
      innerClass: {
        gap: 16,
        [theme.fn.largerThan('sm')]: {
          gap: 24,
        },
      },
      withIconLayout: {
        display: 'flex',
        gap: 16,
        [theme.fn.smallerThan('sm')]: {
          gap: 8,
          flexDirection: 'column',
        },
        '.inner': {
          display: 'flex',
          gap: 16,
          [theme.fn.smallerThan('sm')]: {
            alignItems: 'center',
          },
        },
        '.info': {
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        },
        '.desc-mobile': {
          [theme.fn.largerThan('sm')]: {
            display: 'none',
          },
        },
        '.desc-desktop': {
          [theme.fn.smallerThan('sm')]: {
            display: 'none',
          },
        },
      },
    }
  },
)
